import { useQuery } from '@tanstack/react-query'
import { pemerintahDesaPublicApi, type ChartData } from '@tatatemplate/shared-lib'

export function useOrgChart() {
  return useQuery<ChartData>({
    queryKey: ['org-chart'],
    queryFn: async () => {
      const res = await pemerintahDesaPublicApi.getChartData()
      return res.data
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  })
}
